<template>
  <div class="video-clip">
    <el-page-header @back="$router.go(-1)" content="视频剪辑"> </el-page-header>

    <el-tabs v-model="activeName" type="card" style="margin-top: 20px">
      <el-tab-pane label="评价标准" name="1">
        <Standard category="jj" />
      </el-tab-pane>
      <el-tab-pane label="成果展示" name="2">
        <Result ref="Result" />
      </el-tab-pane>
      <el-tab-pane label="评价窗口" name="3">
        <Evaluate ref="Evaluate" category="jj" />
      </el-tab-pane>
      <el-tab-pane label="英雄榜" name="4" lazy>
        <Ranking category="jj" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Standard from "../standard.vue";
import Evaluate from "../evaluate.vue";
import Ranking from "../ranking.vue";
import Result from "./result.vue";
export default {
  components: { Standard, Evaluate, Result, Ranking },
  data() {
    return {
      activeName: "1",
    };
  },
  watch: {
    activeName(val) {
      if (val == "2") this.$refs.Result.getList();
      else if (val == "3") this.$refs.Evaluate.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.video-clip {
  padding: 20px 33px;
  background-color: #ffffff;
}
</style>